import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { environment } from '@environments/environment';

import {
  AssetsParams,
  GetEventsResult,
  LiveApiAsset,
  LiveApiAssetsParams
} from '@app/modules/location-client/location-api.models';

@Injectable({
  providedIn: 'root'
})
export class LocationApiService {
  constructor(private http: HttpClient) {}

  getAssets(params: AssetsParams): Observable<LiveApiAsset[]> {
    if (!params?.companyId || !params?.vins?.length) {
      return of([]);
    }
    const vdoAssetParams: LiveApiAssetsParams = { accountId: params.companyId, vins: params.vins };
    const url = `${environment.locationApi.url}/vehicle_location?accountId=${vdoAssetParams.accountId}`;
    //const accessControlHeader = new HttpHeaders().set('Access-Control-Max-Age', '86400');
    return this.http.post(url, vdoAssetParams) as Observable<LiveApiAsset[]>; // , { headers: accessControlHeader }
  }

  getSelectedAssetById(accountId: String, assetId: string): Observable<LiveApiAsset> {
    const url = `${environment.locationApi.url}/vehicle_location/${assetId}?accountId=${accountId}`;
    return this.http.get(url) as Observable<LiveApiAsset>;
  }

  getOpenEventsByAssetId(assetId: string, params = null): Observable<GetEventsResult> {
    const url = `${environment.locationApi.url}/events/${assetId}`;
    return this.http.get(url, { params }) as Observable<GetEventsResult>;
  }
}
